import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, letting a later utility win over an earlier one in the
 * same group — so `cn('p-2', 'p-4')` is `p-4`, not both.
 *
 * The shadcn/ui convention. Components take a `className` and pass it through
 * this, which is what makes a variant overridable at the call site without
 * `!important` or a specificity fight.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
